import AboutSection from "../components/portfolio/AboutSection";

const AboutPage = () => {
  return <AboutSection />;
};

export default AboutPage;
